import { useMemo } from "react";
import useGlobalApp from "../../../api/api-hooks/globalApps/useGlobalApp";
import AppSpinner from "../../../elements/AppSpinner";
import AppDrawer from "../../Drawers/AppDrawer";
import AppDetail from "./AppDetail";
import useGetCloudApps from "../../../api/api-hooks/cloudApps/useGetCloudApps";

interface Props {
  appID: string | null;
  onClose: () => void;
  isAdmin: boolean;
}

const AppDetailDrawer = ({ appID, onClose, isAdmin }: Props) => {
  let { globalApp, loadingApp } = useGlobalApp(appID);
  const { cloudApps } = useGetCloudApps();
  const localApp = useMemo(() => {
    return cloudApps?.find((app) => app.id === appID);
  }, [cloudApps, appID]);

  return (
    <AppDrawer
      open={!!appID}
      full
      onClose={onClose}
      headerIcon="arrow-left"
      headerTitle={"Back To All Apps"}
      disablePadding={!loadingApp && !globalApp}
      body={
        loadingApp ? (
          <div className="h-100 w-100 d-flex justify-content-center align-items-center">
            <AppSpinner size="xl" />
          </div>
        ) : (
          <div className="d-flex justify-content-center w-100">
            <AppDetail app={globalApp || localApp} isAdmin={isAdmin} />
          </div>
        )
      }
    />
  );
};

export default AppDetailDrawer;
